import React, { useState } from "react";
import { Button, Card, Container } from "react-bootstrap";
import KeyResourceEditModal from "../edit";
import "./styles.css";

function KeyResourceCard({ res, dispatch, onPin }) {
  const [show, setShow] = useState(false);
  return (
    <Container fluid>
      <Card border="info">
        <Card.Body>
          <Card.Title className="text-center">{res.title}</Card.Title>
          <Card.Text className="text-center d-flex justify-content-between">
            <Button
              style={{ cursor: "pointer", }}
              className={`mr-1 border border-warning`}
              variant={res.pinned === -1 ? "white" : "warning"}
              onClick={() => onPin(res._id, res.pinned === -1)}
            >
              <i className="fas fa-thumbtack"></i>
            </Button>
            <Card.Link
              className="text-truncate"
              target="_blank"
              style={{ display: "table-cell" }}
              href={res.link}
            >
              {res.link}
            </Card.Link>
            <Button
              // variant="warning"
              style={{
                background: "#ffa500",
                color: "black",
                border: "none",
                fontWeight: "500",
              }}
              size="sm"
              onClick={() => setShow(true)}
            >
              Edit
            </Button>
          </Card.Text>
        </Card.Body>
        <KeyResourceEditModal
          dispatch={dispatch}
          show={show}
          onClose={() => setShow(false)}
          res={res}
        />
      </Card>
    </Container>
  );
}

export default KeyResourceCard;
